export default __webpack_public_path__ + "static/media/app-appstore.6dc301ae.svg";